type StorageMethod = (key: string, value?: string) => void

const noop: StorageMethod = () => {}

const isBrowser = () => typeof window !== 'undefined'

const safeGetItem = (key: string): string | null => {
    if (!isBrowser()) {
        return null
    }
    try {
        return window.localStorage.getItem(key)
    } catch {
        return null
    }
}

const safeSetItem: StorageMethod = (key, value = '') => {
    if (!isBrowser()) {
        return
    }
    try {
        window.localStorage.setItem(key, value)
    } catch {
        // Swallow storage write errors (e.g. quota exceeded, disabled storage)
    }
}

const safeRemoveItem: StorageMethod = (key) => {
    if (!isBrowser()) {
        return
    }
    try {
        window.localStorage.removeItem(key)
    } catch {
        // Swallow storage removal errors
    }
}

export const safeLocalStorage = {
    getItem: safeGetItem,
    setItem: safeSetItem,
    removeItem: safeRemoveItem,
}
